import { createFileRoute } from "@tanstack/react-router";
import { PlatformSchedulerPage } from "@/components/platform-scheduler-page";
import { buildPageHead } from "@/lib/seo-meta";

const path = "/channels/linkedin";

export const Route = createFileRoute(path)({
	component: LinkedInScheduler,
	head: ({ matches }) =>
		buildPageHead({
			matches,
			internalPath: path,
			title: "AgentReacher | Connect your AI agent to LinkedIn",
			description:
				"Schedule LinkedIn posts with an AI social media agent. Draft in your voice, build a weekly calendar from one prompt, and publish on time.",
		}),
});

function LinkedInScheduler() {
	return (
		<PlatformSchedulerPage
			platform="linkedin"
			platformLabel="LinkedIn"
			hero={{
				title: "Connect your AI agent to LinkedIn",
				description:
					"Give AgentReacher a campaign idea, changelog, or customer lesson. It turns the brief into LinkedIn posts that read like you, places them on the calendar, and waits for approval.",
			}}
		/>
	);
}
